import { createEvoClient, storeCancellationRequest } from "@jti/evo-client";
import { getConfig, keysToCamelCase } from "@jti/fe-common";
import type { CancellationRequestBody } from "@jti/rest-api-types";

import { getUser } from "../../utils";

export class OrderCancellationApi {
  readonly name = "OrderCancellationApi";
  private readonly client;
  private readonly user;

  constructor() {
    const config = getConfig();
    this.user = getUser();

    const baseUrl = config.EVO_DOMAIN;

    this.client = createEvoClient({
      baseUrl,
      recaptchaId: config["X-RECAPTCHA-ID"],
      tenantToken: config.EVO_TENANT,
      ciamToken: this.user.ciam_token,
      throwOnError: true,
    });
  }

  async sendCancellationRequest(data: CancellationRequestBody) {
    if (!this.user.uuid) {
      throw new Error("uuid is not defined");
    }

    const response = await storeCancellationRequest({
      client: this.client,
      throwOnError: true,
      body: data,
    });

    return keysToCamelCase(response.data);
  }
}
